import PageCollection from '../../base/collections/page';

import { Transaction } from '../models/transaction';

export const TransactionList = PageCollection.extend({
  model: Transaction,

  state: {
      pageSize: 20,
      pagesInRange: 10
  }
});



// WEBPACK FOOTER //
// ./epayment/collections/transaction.js